import { ReactNode } from "react";
import { Avatar, AvatarFallback } from "./shad/avatar";
import { cn } from "@/lib/utils";

interface Props {
  steps: StepType[];
  spacing?: string;
}

export type StepType = {
  element: ReactNode;
};

const VerticalStepper = ({ steps, spacing }: Props) => {
  // const steps = [
  //     {
  //         label: "Hi I'm a title",
  //         body: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dignissimos, nobis non pariatur quae, quam temporibus minus vero magni eius aliquam tempore sint quibusdam quasi alias natus obcaecati quisquam. Delectus, magnam?'
  //     },
  //     {
  //         label: "Hi I'm a title",
  //         body: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dignissimos, nobis non pariatur quae, quam temporibus minus vero magni eius aliquam tempore sint quibusdam quasi alias natus obcaecati quisquam. Delectus, magnam?Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quaerat recusandae nesciunt quibusdam exercitationem placeat atque consectetur aliquam et assumenda nam eligendi, totam laboriosam asperiores aliquid nemo, ipsa qui, animi iusto.Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quaerat recusandae nesciunt quibusdam exercitationem placeat atque consectetur aliquam et assumenda nam eligendi, totam laboriosam asperiores aliquid nemo, ipsa qui, animi iusto.'
  //     },
  // ]
  return (
    <div>
      <div className={cn("grid  w-full", spacing ?? "gap-4")}>
        {steps.map((item, index) => (
          <div key={index}>
            <div className="flex gap-3">
              {/* <span className="rounded-full bg-blue-700 p-2">{index + 1}</span> */}
              <div className="hidden md:flex flex-col items-center">
                <Avatar className="p-1">
                  <AvatarFallback className="bg-[#2F60E0] p-1 text-white">
                    {index + 1}
                  </AvatarFallback>
                </Avatar>
                {index + 1 !== steps.length && (
                  <div className="border-l border-gray-200 dark:border-grey-400 h-full"></div>
                )}
              </div>
              <div className="w-full">{item?.element}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VerticalStepper;
